import { SvgIcon } from "@mui/material"

import { ReactComponent as StructureIcon } from "./Structure.svg"

export const RoadStructureIcon = (props) => {
    return (
        <SvgIcon component={StructureIcon} {...props} inheritViewBox />
    )
}